import request from '../request';

// 绑定意向项目
function bindUserProject (data) {
  return request({
    url: '/usercenter/front/api/account/bindProject',
    method: 'PUT',
    data,
  });
}

// 添加渠道标签
function addChannelTag (data) {
  return request({
    url: '/usercenter/front/api/account/addChannelTag',
    method: 'POST',
    data,
  });
}

export default {
  bindUserProject,
  addChannelTag
};
